module.exports = __webpack_public_path__ + "img/new10.eec4991a.png";